export default function InfoBox({image, alt, title, comment}) {
  return (
  <div className="flex items-center justify-start mx-3 my-3 w-[90%] lg:w-[600px] xl:w-[700px]">
    <div className="mr-4">
      <img src={image} alt={alt} className="w-[100px] lg:min-w-[60px]"/>
    </div>
    <div className="flex flex-col items-stretch justify-center">
      <div className="mb-1.5 mx-1">
        <p className="text-base font-medium text-white lg:text-[23px] break-keep">{title}</p>
      </div>
      <div><p className="text-xs text-[#CCCCFB] lg:text-[15px]">{comment}</p></div>
    </div>
  </div>
  );
}